import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { IDepartment } from 'types/income';
import { getSorting } from 'utils/general';
import { DepartmentsFilters } from './departments.types';

interface GetDepartments {
  filters: Partial<DepartmentsFilters>;
}

interface CreateDepartment {
  companyId: string;
  name: string;
  hidden: boolean;
  managerId: string | null;
}

interface UpdateDepartment {
  departmentId: string;
  data: Partial<Omit<CreateDepartment, 'companyId'>>;
}

interface DeleteDepartment {
  departmentId: string;
}

export const loaders = {
  getDepartments: ({ filters }: GetDepartments) => {
    return api<TableDataResponse<IDepartment>>({
      url: Endpoints.clientAdmin.departments.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        ...getSorting(filters.sort),
        search: filters.search || undefined,
        filter: {
          departmentIds: filters.departments,
          companyIds: filters.companies,
          isHidden: filters.isHidden,
        },
      },
    });
  },
  createDepartment: ({ ...data }: CreateDepartment) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.departments.root,
      data,
      method: 'post',
    });
  },
  updateDepartment: ({ departmentId, data }: UpdateDepartment) => {
    return api({
      url: Endpoints.clientAdmin.departments.byId.replace(
        ':departmentId',
        departmentId,
      ),
      data,
      method: 'patch',
    });
  },
  deleteDepartment: ({ departmentId }: DeleteDepartment) => {
    return api({
      url: Endpoints.clientAdmin.departments.byId.replace(
        ':departmentId',
        departmentId,
      ),
      method: 'delete',
    });
  },
};
